class calendarResponseComponent {
  constructor(vue) {
    this.context = vue
    this.appId = ""
    this.request_prefix = this.context.request_prefix
    this.restUrl = null // 分类数据
    this.containerId = 0
  }
  init() {
    this.getRelativeInfo()
  }
  getRelativeInfo() {
    //通栏中查找rectid
    let relativeId = this.context.options.relativeComponentId
    if (!relativeId) {
      return false
    }
    //  监听
    this.initCalendarWatcher(relativeId)
  //  样式3默认传参当周失效，排查发现传递参数时，对应自动布局未渲染完成导致传参失效
  //  延迟时长传递参数
    if(this.context.styleId === 3){
      setTimeout(()=>{
        const self = this
        let dateArr = []
        //添加sf  ef参数的值
        if (self.context.options.startDateFlag) {
          dateArr.push(self.context.options.startDateFlag)
        } else {
          dateArr.push(6)
        }
        if (self.context.options.endDateFlag) {
          dateArr.push(self.context.options.endDateFlag)
        } else {
          dateArr.push(6)
        }
        let thisWeek = self.context.options.thisWeek
        dateArr.push(thisWeek[0])
        dateArr.push(thisWeek[6])
        self.postUpdate(relativeId, dateArr)
      }, 500)
    }
  }
  initCalendarWatcher(relativeId) {
    const self = this
    this.context.$watch(
      function () {
        return self.context.options.pickDate
      },
      async function (newVal, oldVal) {
        let dateArr = []
        //添加sf  ef参数的值
        if (self.context.options.startDateFlag) {
          dateArr.push(self.context.options.startDateFlag)
        } else {
          dateArr.push(6)
        }
        if (self.context.options.endDateFlag) {
          dateArr.push(self.context.options.endDateFlag)
        } else {
          dateArr.push(6)
        }
        //未选择具体哪一天 图文/文本列表显示当月的数据
        if (!newVal || !oldVal) {
          // 兼容选中日期取消选中效果
          if (self.context.options?.selectMonth && !newVal && oldVal) {
            let newDate = oldVal.split("-")
            //获取月末的日期
            let lastD = new Date(newDate[0], newDate[1], 0).getDate()
            let month1 = Number(newDate[1]) < 10 ? "0" + Number(newDate[1]) : Number(newDate[1])
            let firstDate = newDate[0] + "-" + month1 + "-01"
            let lastDate = newDate[0] + "-" + month1 + "-" + lastD
            dateArr.push(firstDate)
            dateArr.push(lastDate)
            self.postUpdate(relativeId, dateArr)
          } else if (self.context.options?.selectWeek && !newVal && oldVal) {
            let thisWeek = self.context.options.thisWeek
            if(thisWeek){
              dateArr.push(thisWeek[0])
              dateArr.push(thisWeek[6])
            }else{
              //获取周末的日期
              let formatDate = function (date) {
                let year = date.getFullYear() //年
                let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
                let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
                return year + "-" + month + "-" + day
              }
              let addDate = function (date, n) {
                date.setDate(date.getDate() - 1 + n)
                return date
              }
              let data1 = formatDate(addDate(new Date(oldVal), 7))
              dateArr.push(oldVal)
              dateArr.push(data1)
            }
            self.postUpdate(relativeId, dateArr)
          } else if(!self.context.options?.selectWeek && newVal ){
            if(self.context.styleId === 1){
              // 解决取消选中日期后再次点击选中失效的问题
              if(!self.context.options?.selectMonth && !oldVal){
                self.hasNewDateFunc(newVal, relativeId, dateArr)
              }else{
                //样式1修改为默认取当月数据
                dateArr = self.getNowMonthDates(dateArr)
                setTimeout(() => {
                  self.postUpdate(relativeId, dateArr)
                }, 300)
              }
            }else{
              //解决多次选中同一天的情况
              self.hasNewDateFunc(newVal, relativeId, dateArr)
            }
          }
          else {
            if(self.context.styleId === 3){
              dateArr = self.getNowWeekDates(dateArr)
            }else{
              dateArr = self.getNowMonthDates(dateArr)
            }
            setTimeout(() => {
              self.postUpdate(relativeId, dateArr)
            }, 300)
          }
        } else if (self.context.options?.selectMonth) {
          let newDate = newVal.split("-")
          //获取月末的日期
          let lastD = new Date(newDate[0], newDate[1], 0).getDate()
          let month1 = Number(newDate[1]) < 10 ? "0" + Number(newDate[1]) : Number(newDate[1])
          let date1 = Number(newDate[2]) < 10 ? "0" + Number(newDate[2]) : Number(newDate[2])
          let lastDate = newDate[0] + "-" + month1 + "-" + lastD
          newDate = newDate[0] + "-" + month1 + "-" + date1
          dateArr.push(newDate)
          dateArr.push(lastDate)
          self.postUpdate(relativeId, dateArr)
        } else if (self.context.options?.selectWeek) {
          //获取周末的日期
          let formatDate = function (date) {
            let year = date.getFullYear() //年
            let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
            let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
            return year + "-" + month + "-" + day
          }
          let addDate = function (date, n) {
            date.setDate(date.getDate() - 1 + n)
            return date
          }
          let data1 = formatDate(addDate(new Date(newVal), 7))
          dateArr.push(newVal)
          dateArr.push(data1)
          self.postUpdate(relativeId, dateArr)
        } else {
          self.hasNewDateFunc(newVal, relativeId, dateArr)
        }
      },
      {
        immediate: true
      }
    )
  }
  getNowMonthDates(dateArr) {
    //  获取当月的数据
    let date = new Date()
    let year = date.getFullYear()
    let month = Number(date.getMonth() + 1) < 10 ? "0" + Number(date.getMonth() + 1) : Number(date.getMonth() + 1)
    let firstDay = year + "-" + month + "-01"
    let nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1)
    let lastDay1 = new Date(nextMonth.getTime() - 1000 * 60 * 60 * 24)
    let lastDay = year + "-" + month + "-" + lastDay1.getDate()
    dateArr.push(firstDay)
    dateArr.push(lastDay)
    return dateArr
  }
  getNowWeekDates(dateArr){
    //  获取当周的数据
    dateArr.push(this.context.starttime)
    dateArr.push(this.context.endtime)
    return dateArr
  }
  postUpdate(relativeId, dateArr) {
    const self = this
    const rect_id = self.context.myid?.rect_id || self.context.ids?.rect_id
    dateArr.push(rect_id)
    let idsArr = []
    if(typeof relativeId === "string" && relativeId.indexOf("_autoLayout_") > -1){
      let selfId = self.context.myid?.elementInAutoLayoutId || self.context.ids?.elementInAutoLayoutId
      dateArr.push(selfId)
      idsArr = relativeId.split("_autoLayout_")
      relativeId = Number(idsArr[0])
    }
    // 通知列表更新数据
    self.context.$eventBus.$emit(`update-layout-data-eventBus-${self.containerId}-${relativeId}`, {
      dateVal: dateArr
    })
  }
  hasNewDateFunc(newVal, relativeId, dateArr) {
    let self = this
    let newDate = newVal.split("-")
    let month1 = Number(newDate[1]) < 10 ? "0" + Number(newDate[1]) : Number(newDate[1])
    let date1 = Number(newDate[2]) < 10 ? "0" + Number(newDate[2]) : Number(newDate[2])
    newDate = newDate[0] + "-" + month1 + "-" + date1
    dateArr.push(newDate)
    dateArr.push(newDate)
    self.postUpdate(relativeId, dateArr)
  }
}
export default {
  methods: {
    calendarResponseDataPlugin() {
      const calendar1 = new calendarResponseComponent(this)
      calendar1.init()
    }
  }
}
